import client from '../lib/http-client';

export default {
	// Get Statistic
	getStatistic(params, cb, errorCb) {
		client.post('/statistic', { ...params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Weekly Snapshots
	getSnapshots(params, cb, errorCb) {
		client.post('/statistic/snapshot', { body: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Daily Statistic
	getDailyStatistic(params, cb, errorCb) {
		client.post('/statistic/daily', params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Customer Statistic
	getCustomerStatistic(params, cb, errorCb) {
		client.post('/statistic/customer', params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Follow Up Statistic
	getFollowUpConversionStatistic(params, cb, errorCb) {
		client.post('/statistic/followup_conversion', params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Tracking Statistic
	getTrackingStatistic(params, cb, errorCb) {
		client.post('/statistic/tracking', params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
